import React from 'react';
import styles from './Button.module.scss';

function Button({ type = 'primary', size = 'default', className = '', children, href, typeButton, ...props }) {
  const typeClass =
    type === 'primary' ? styles.primary :
    type === 'secondary' ? styles.secondary :
    type === 'destructive' ? styles.destructive :
    '';
  const sizeClass =
    size === 'small' ? styles.small :
    size === 'default' ? styles.default :
    '';
  const classNames = `${styles.button} ${typeClass} ${sizeClass} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        className={classNames}
        role="button"
        tabIndex={0}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
}

export default Button; 